// Legal data — Fernando Marcos Subastas & Investment
export const LEGAL = {
  ownerName: "Fernando Marcos Moya",
  legalForm: "Persona física · Empresario individual (autónomo)",
  taxId: "45.091.305-N",
  address: "Avenida Príncipe Salman, C1, 3.º B-W, 29603 Marbella, Málaga, España",
  email: "fmsubastasinvestment@gmail.com",
  emailOps: "informes@fmsubastas.com",
  phone: "+34 695 536 486",  // visible solo en páginas comerciales — NO en legales
  domain: "fmsubastas.com",
  tradename: "Fernando Marcos Subastas & Investment",
  brand: "FM Subastas & Investment",
  websiteUrl: "https://fmsubastas.com",
  lastUpdated: "15/02/2026",
};
